import { render, staticRenderFns } from "./dentistryTwo.vue?vue&type=template&id=67fac911&scoped=true"
import script from "./dentistryTwo.vue?vue&type=script&lang=js"
export * from "./dentistryTwo.vue?vue&type=script&lang=js"
import style0 from "./dentistryTwo.vue?vue&type=style&index=0&id=67fac911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fac911",
  null
  
)

export default component.exports